import React from 'react';
import { MapPin, Home, Clock } from 'lucide-react';
export function ServiceAreasSection() {
  const areas = [{
    name: 'Fresno',
    description: 'Downtown to North Fresno'
  }, {
    name: 'Clovis',
    description: 'Old Town to Copper River Ranch'
  }, {
    name: 'Madera County',
    description: 'Oakhurst to Madera'
  }, {
    name: 'Tulare County',
    description: 'Visalia to Exeter'
  }];
  return <section className="py-16 bg-white border-t border-gray-100" data-id="element-206">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-207">
        <div className="text-center mb-12" data-id="element-208">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-blue/10 rounded-full mb-4" data-id="element-209">
            <MapPin className="w-8 h-8 text-brand-blue" data-id="element-210" />
          </div>
          <h2 className="text-2xl md:text-3xl font-semibold text-brand-blue mb-3" data-id="element-211">
            Proudly Serving the Central Valley
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-212">
            Local expertise with deep roots in Fresno and surrounding
            communities. We're never more than 30 minutes away.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-213">
          {areas.map((area, index) => <div key={index} className="bg-gray-50 p-6 rounded-lg border border-gray-200 hover:border-brand-blue hover:shadow-md transition-all text-center" data-id="element-214">
              <h3 className="font-bold text-brand-black text-lg mb-2" data-id="element-215">
                {area.name}
              </h3>
              <p className="text-sm text-gray-600" data-id="element-216">{area.description}</p>
            </div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-217">
          <div className="flex items-start gap-4 bg-brand-blue/5 p-6 rounded-lg" data-id="element-218">
            <div className="flex-shrink-0" data-id="element-219">
              <Home className="w-6 h-6 text-brand-blue" data-id="element-220" />
            </div>
            <div data-id="element-221">
              <h4 className="font-semibold text-brand-black mb-1" data-id="element-222">
                Local & Family-Owned
              </h4>
              <p className="text-sm text-gray-600" data-id="element-223">
                Based in Fresno since 1997, we understand Central Valley homes
                and building codes
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4 bg-brand-blue/5 p-6 rounded-lg" data-id="element-224">
            <div className="flex-shrink-0" data-id="element-225">
              <Clock className="w-6 h-6 text-brand-blue" data-id="element-226" />
            </div>
            <div data-id="element-227">
              <h4 className="font-semibold text-brand-black mb-1" data-id="element-228">
                Fast Response Times
              </h4>
              <p className="text-sm text-gray-600" data-id="element-229">
                Same-day quotes available. We're local, so we can be on-site
                quickly
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}